require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./ateliers-dclic-de-la-facult-ic-0-7-0-1.json") })
        }
      }, "path---ateliers-dclic-de-la-facult-ic-0-7-0-1");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---ateliers-dclic-de-la-facult-ic-0-7-0-1!./.cache/json/ateliers-dclic-de-la-facult-ic-0-7-0-1.json
// module id = 340
// module chunks = 231608221292675